export const TOKEN_KEY = 'swapzz-token'